import { useUserStore } from "@/stores/UserStore";

/**
 * Check if user has permission for a specific menu item
 * @param {Object} item - Menu item to check
 * @param {Array} userPages - Array of user's permitted pages
 * @returns {boolean} - True if user has permission
 */
export function hasPermissionForMenuItem(item, userPages) {
  // Check if any of the item's permissions are in user's pages
  if (item.permissions && item.permissions.length > 0) {
    return item.permissions.some((permission) =>
      userPages.includes(permission)
    );
  }

  // If no direct permissions, check if any child has permissions
  if (item.child && item.child.length > 0) {
    return item.child.some((child) =>
      hasPermissionForMenuItem(child, userPages)
    );
  }

  // If no permissions and no children, show by default
  return true;
}

/**
 * Determine if a menu item should be displayed based on permissions and visibility settings
 * @param {Object} item - Menu item to check
 * @returns {boolean} - True if item should be displayed
 */
export function shouldDisplayMenuItem(item) {
  // Get user's pages from the store
  const userStore = useUserStore();
  const userPages = userStore.user?.role?.pages || [];

  // First check if user has permission for this item
  const hasPermission = hasPermissionForMenuItem(item, userPages);

  // If user doesn't have permission and always_visible is false, hide the item
  if (!hasPermission && item.always_visible === false) {
    return false;
  }

  // For parent items, check if any children should be displayed
  if (item.child && item.child.length > 0) {
    const hasVisibleChildren = item.child.some(child =>
      shouldDisplayMenuItem(child)
    );
    // If no children are visible, don't show the parent
    if (!hasVisibleChildren) {
      return false;
    }
  }

  // Default: show the item (either has permission or always_visible is true)
  return true;
}
